import { render, staticRenderFns } from "./FormBrokerBlocklist.vue?vue&type=template&id=319e59b0"
import script from "./FormBrokerBlocklist.vue?vue&type=script&lang=js"
export * from "./FormBrokerBlocklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports